module.exports = __webpack_public_path__ + "img/Avatar-91.503649d0.svg";